/** Bileşenler arası hafif senkronizasyon (ör. üst çubuk organizasyon listesi). */
export const ORGANIZATIONS_LIST_REFRESH_EVENT = 'spsnexus:organizations-list-refresh';

export function dispatchOrganizationsListRefresh() {
  window.dispatchEvent(new CustomEvent(ORGANIZATIONS_LIST_REFRESH_EVENT));
}
